import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'

export class UpdateSpinWheelBranchEntity {
  branchs?: BranchMiniEntity[]
}
